import React from 'react'
import { PageProps } from 'gatsby'

// Lazy loading
import loadable from '@loadable/component'

export interface CertificationsProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Certifications
  location: PageProps['location']
}

interface PostProps {
  [key: string]: any
}

const CertificationsShell: React.FC<CertificationsProps> = ({
  fields,
  location,
}) => {
  const types: PostProps = {
    default: loadable(
      () => import('components/flex/Certifications/Certifications')
    ),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default CertificationsShell
